import React from 'react';
import './WaitingRoom.css'; 
import ThemeSelect from '../common/ThemeSelect';

export default function MatchSettings({ mode, settings, send, isHost }) {
  
  const updateSetting = (key, value) => {
    if (!isHost) return;
    const newSettings = { ...settings, [key]: value };
    send('update_settings', newSettings);
  };

  const handleTrackScoreToggle = (newValue) => {
    updateSetting('track_score', newValue);
  };

  const trackScoreRow = (
    <div className="setting-row">
      <div className="setting-info">
        <span className="setting-label">Track Score</span>
        <span className="setting-desc">Save match results to leaderboard</span>
      </div>
      <div className="setting-control">
        {isHost ? (
          <div className="button-group">
            <button 
              className={`toggle-btn ${settings.track_score !== false ? 'active' : ''}`}
              onClick={() => handleTrackScoreToggle(true)}
            >
              Enabled
            </button>
            <button 
              className={`toggle-btn ${settings.track_score === false ? 'active' : ''}`}
              onClick={() => handleTrackScoreToggle(false)}
            >
              Disabled
            </button>
          </div>
        ) : (
          <span className={`setting-badge ${settings.track_score !== false ? 'enabled' : 'disabled'}`}>
            {settings.track_score !== false ? 'Enabled' : 'Disabled'}
          </span>
        )}
      </div>
    </div>
  );

  // --- POKER SETTINGS ---
  if (mode === 'poker') {
    return (
      <div className="match-settings-container">
        <div className="setting-row">
          <div className="setting-info">
            <span className="setting-label">Player Count</span>
            <span className="setting-desc">Number of players at the table</span>
          </div>
          <div className="setting-control">
            {isHost ? (
              <div className="button-group">
                <button 
                  className={`toggle-btn ${settings.player_count === 4 ? 'active' : ''}`}
                  onClick={() => updateSetting('player_count', 4)}
                >
                  4 Players
                </button>
                <button 
                  className={`toggle-btn ${settings.player_count === 6 ? 'active' : ''}`}
                  onClick={() => updateSetting('player_count', 6)}
                >
                  6 Players
                </button>
              </div>
            ) : (
               <span className="setting-badge enabled">
                {settings.player_count === 6 ? '6 Players' : '4 Players'}
              </span>
            )}
          </div>
        </div>

        <div className="setting-row">
          <div className="setting-info">
            <span className="setting-label">Blinds</span>
            <span className="setting-desc">Small and Big Blind amounts</span>
          </div>
          <div className="setting-control">
            {isHost ? (
              <ThemeSelect 
                value={settings.blinds || "10/20"} 
                onChange={(e) => updateSetting('blinds', e.target.value)}
                options={[
                  { value: '5/10', label: '5 / 10' },
                  { value: '10/20', label: '10 / 20' },
                  { value: '25/50', label: '25 / 50' },
                  { value: '50/100', label: '50 / 100' },
                  { value: '100/200', label: '100 / 200' }
                ]}
              />
            ) : (
              <span className="setting-badge">{settings.blinds || "10/20"}</span>
            )}
          </div>
        </div>

        <div className="setting-row">
          <div className="setting-info">
            <span className="setting-label">Buy-in</span>
            <span className="setting-desc">Starting chips for each player</span>
          </div>
          <div className="setting-control">
            {isHost ? (
              <ThemeSelect 
                value={settings.buy_in || 1000} 
                onChange={(e) => updateSetting('buy_in', parseInt(e.target.value))}
                options={[
                  { value: '500', label: '500 Chips' },
                  { value: '1000', label: '1000 Chips' },
                  { value: '2000', label: '2000 Chips' },
                  { value: '5000', label: '5000 Chips' },
                  { value: '10000', label: '10000 Chips' }
                ]}
              />
            ) : (
              <span className="setting-badge">{settings.buy_in || 1000} Chips</span>
            )}
          </div>
        </div>
        {trackScoreRow}
      </div>
    );
  }

  // --- DONKEY (KAZHUTHA) SETTINGS ---
  if (mode === 'donkey') {
    return (
      <div className="match-settings-container">
        <div className="setting-row">
          <div className="setting-info">
            <span className="setting-label">Player Count</span>
            <span className="setting-desc">Number of players in the game</span>
          </div>
          <div className="setting-control">
            {isHost ? (
              <div className="button-group">
                <button 
                  className={`toggle-btn ${settings.player_count === 4 ? 'active' : ''}`}
                  onClick={() => updateSetting('player_count', 4)}
                >
                  4 Players
                </button>
                <button 
                  className={`toggle-btn ${settings.player_count === 6 ? 'active' : ''}`}
                  onClick={() => updateSetting('player_count', 6)}
                >
                  6 Players
                </button>
              </div>
            ) : (
              <span className="setting-badge">{settings.player_count === 6 ? '6 Players' : '4 Players'}</span>
            )}
          </div>
        </div>
        {trackScoreRow}
      </div>
    );
  }

  // --- LUDO SETTINGS ---
  if (mode === 'ludo') {
    return (
      <div className="match-settings-container">
        <div className="setting-row">
          <div className="setting-info">
            <span className="setting-label">Player Count</span>
            <span className="setting-desc">4 Players (Classic)</span>
          </div>
          <div className="setting-control">
             <span className="setting-badge enabled">4 Players</span>
          </div>
        </div>
        
        <div className="setting-row" style={{ borderBottom: 'none' }}>
          <div className="setting-info">
            <span className="setting-label">Ruleset</span>
            <span className="setting-desc">Classic (Captures, Blockades & Safe Squares)</span>
          </div>
        </div>
        {trackScoreRow}
      </div>
    );
  }

  // --- 28 & 56 SETTINGS ---
  return (
    <div className="match-settings-container">
      
      {/* 0. Win Condition (Sprint Series / Escalation) */}
      <div className="setting-row">
        <div className="setting-info">
          <span className="setting-label">Win Condition</span>
          <span className="setting-desc">Classic, Round Limit, or Timed Escalation</span>
        </div>
        <div className="setting-control" style={{ flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
          {isHost ? (
            <>
              <ThemeSelect 
                value={settings.escalation_timer ? 'escalation' : (settings.sprint_rounds > 0 ? 'sprint' : 'classic')}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === 'classic') {
                    send('update_settings', { ...settings, sprint_rounds: 0, escalation_timer: false });
                  } else if (val === 'sprint') {
                    send('update_settings', { ...settings, sprint_rounds: 5, escalation_timer: false });
                  } else if (val === 'escalation') {
                    send('update_settings', { ...settings, sprint_rounds: 0, escalation_timer: true });
                  }
                }}
                options={[
                  { value: 'classic', label: 'Classic' },
                  { value: 'sprint', label: 'Sprint Series' },
                  { value: 'escalation', label: 'Escalation Protocol' }
                ]}
              />
              {settings.sprint_rounds > 0 && (
                <ThemeSelect 
                  value={settings.sprint_rounds}
                  onChange={(e) => send('update_settings', { ...settings, sprint_rounds: parseInt(e.target.value) })}
                  options={[
                    { value: '5', label: '5 Rounds' },
                    { value: '10', label: '10 Rounds' },
                    { value: '15', label: '15 Rounds' },
                    { value: '20', label: '20 Rounds' },
                    { value: '25', label: '25 Rounds' },
                    { value: '30', label: '30 Rounds' },
                    { value: '35', label: '35 Rounds' },
                    { value: '40', label: '40 Rounds' },
                    { value: '45', label: '45 Rounds' },
                    { value: '50', label: '50 Rounds' }
                  ]}
                />
              )}
            </>
          ) : (
            <span className="setting-badge">
              {settings.escalation_timer 
                ? 'Escalation Protocol' 
                : (settings.sprint_rounds > 0 ? `Sprint: ${settings.sprint_rounds} Rounds` : 'Classic')}
            </span>
          )}
        </div>
      </div>
      
      {/* 1. Deal Mode */}
      <div className="setting-row">
        <div className="setting-info">
          <span className="setting-label">Deal Mode</span>
          <span className="setting-desc">How cards are dealt to players</span>
        </div>
        <div className="setting-control">
          {isHost ? (
            <ThemeSelect 
              value={settings.deal_mode || 'full'}
              onChange={(e) => updateSetting('deal_mode', e.target.value)}
              options={[
                { value: 'full', label: 'Full Deal (All at once)' },
                { value: 'phase', label: 'Phase Deal (4 then rest)' }
              ]}
            />
          ) : (
            <span className="setting-badge">{settings.deal_mode === 'full' ? 'Full Deal' : 'Phase Deal'}</span>
          )}
        </div>
      </div>

      {/* 2. Allow Doubling */}
      <div className="setting-row">
        <div className="setting-info">
          <span className="setting-label">Double / Redouble</span>
          <span className="setting-desc">Allow defenders to double the stakes</span>
        </div>
        <div className="setting-control">
          {isHost ? (
            <div className="button-group">
              <button 
                className={`toggle-btn ${settings.allow_doubling !== false ? 'active' : ''}`}
                onClick={() => updateSetting('allow_doubling', true)}
              >
                Enabled
              </button>
              <button 
                className={`toggle-btn ${settings.allow_doubling === false ? 'active' : ''}`}
                onClick={() => updateSetting('allow_doubling', false)}
              >
                Disabled
              </button>
            </div>
          ) : (
             <span className={`setting-badge ${settings.allow_doubling !== false ? 'enabled' : 'disabled'}`}>
              {settings.allow_doubling !== false ? 'Enabled' : 'Disabled'}
            </span>
          )}
        </div>
      </div>

      {/* 3. Royal Pair (Meli) */}
      <div className="setting-row">
        <div className="setting-info">
          <span className="setting-label">Royal Pair (Meli)</span>
          <span className="setting-desc">King & Queen of Trump adjust target by 4</span>
        </div>
        <div className="setting-control">
          {isHost ? (
            <div className="button-group">
              <button 
                className={`toggle-btn ${settings.royal_pair ? 'active' : ''}`}
                onClick={() => updateSetting('royal_pair', true)}
                disabled={mode !== '28'} 
              >
                Enabled
              </button>
              <button 
                className={`toggle-btn ${!settings.royal_pair ? 'active' : ''}`}
                onClick={() => updateSetting('royal_pair', false)}
                disabled={mode !== '28'}
              >
                Disabled
              </button>
            </div>
          ) : (
             <span className={`setting-badge ${settings.royal_pair ? 'enabled' : 'disabled'}`}>
              {settings.royal_pair ? 'Enabled' : 'Disabled'}
            </span>
          )}
        </div>
      </div>

      {trackScoreRow}
    </div>
  );
}